// extracted by mini-css-extract-plugin
export default {"icon":"Icons_icon__JfSa3"};